export const Languages = [
  {
    label: 'Australia',
    value: 'au',
    currency: 'AUD'
  },
  {
    label: 'New Zealand',
    value: 'nz',
    currency: 'NZD'
  }
];


export function getCurrencyByCountry(country = 'au'): string {
  const language = Languages.find(item => item.value === country);
  return language ? language.currency : '';
}
